import Control from "../../1. Core/Control";
import Delegate from "../../1. Core/Delegate";
import IconSelect from "../../1. Core/Controls/Select/IconSelect";
import ListGroupHeader from "../../1. Core/Controls/ListBox/ListGroupHeader";
import Select from "../../1. Core/Controls/Select/Select";
import NP from "../../1. Core/NP";
import Button from "../../1. Core/Controls/Button/Button";
import {UserFilter} from "./types";
import EditPushScheduleDlg from "./EditPushScheduleDlg";


export default class UsersFilterPanel extends Control {

    public EvFilterSortChanged: Delegate;
    public EvSendNotificationClick: Delegate;

    private _sortFieldCombo: IconSelect;
    private _sortDirectionCombo: IconSelect;
    private _sortLabel: ListGroupHeader;

    private _hasSubCombo: Select;
    private _dateFilterCombo: IconSelect;
    private _sendNotBtn: Button;
    private _device: IconSelect;
    private _createNotBtn: Button;


    _initFields(settings: object) {
        this.EvSendNotificationClick = new Delegate();
        this.EvFilterSortChanged = new Delegate();
        super._initFields(settings);
    }

    constructor(settings: object) {

        super(settings);
        this._render();
    }

    _render() {
        this._initComponent('<div class="filter-panel"></div>');

        new ListGroupHeader({
            ParentNode: this._root,
            RK: 'Parameters',
            Class: 'app-list-group__subheader--accent'
        });

        this._dateFilterCombo = new IconSelect({
            ParentNode: this._root,
            FloatingLabel: 'Last activity date',
            SelectedIndex: 0,
            Items: [
                {RK: 'All', Value: 'All', FontImage: NP.FontImages.event},
                {Content: 'Last 7 Days', Value: '7.days', FontImage: NP.FontImages.event},
                {Content: 'Last 30 Days', Value: '30.days', FontImage: NP.FontImages.event},
                {Content: 'Last 60 Days', Value: '60.days', FontImage: NP.FontImages.event}
            ],
            EvItemSelected: () => {
                this._applyFiltersSort();
            }
        });

        this._hasSubCombo = new IconSelect({
            ParentNode: this._root,
            FloatingLabel: 'Has Subscription',
            Value: 'All',
            Items: [
                {RK: 'All', Value: 'All', FontImage: NP.FontImages.event},
                {
                    Content: 'Yes',
                    Value: 'Yes',
                    FontImage: NP.FontImages.event
                },
                {Content: 'No', Value: 'No', FontImage: NP.FontImages.event}
            ],
            EvItemSelected: () => {
                this._applyFiltersSort();
            }
        });

        this._device = new IconSelect({
            ParentNode: this._root,
            FloatingLabel: 'Filter',
            SelectedIndex: 0,
            Items: [
                {Content: 'All', Value: 'all', FontImage: NP.FontImages.event},
                {Content: 'Exclude bots', Value: 'no-bots', FontImage: NP.FontImages.event},
                {Content: 'Bots', Value: 'bots', FontImage: NP.FontImages.event},
                {Content: 'Android', Value: 'android', FontImage: NP.FontImages.event},
                {Content: 'Apple', Value: 'apple', FontImage: NP.FontImages.event},
                {Content: 'Web', Value: 'web', FontImage: NP.FontImages.event},
            ],
            EvItemSelected: () => {
                this._applyFiltersSort();
            }
        });

        this._hasSubCombo.setValue('All', false)

        this._sortLabel = new ListGroupHeader({
            ParentNode: this._root,
            RK: 'OrderBy',
            Class: 'app-list-group__subheader--accent'
        });

        this._sortFieldCombo = new IconSelect({
            ParentNode: this._root,
            SelectedIndex: 0,
            Items: [{
                Value: 'RegisterDate',
                FontImage: NP.FontImages.sort,
                Content: 'RegisterDate'
            }, {
                Value: 'LastActivityDate',
                FontImage: NP.FontImages.sort,
                Content: 'LastActivityDate'
            }],
            EvItemSelected: () => this._applyFiltersSort()
        });

        this._sortDirectionCombo = new IconSelect({
            ParentNode: this._root,
            SelectedIndex: 0,
            Items: [{
                Value: -1,
                FontImage: NP.FontImages.arrow_downward,
                Content: NP.RM.getString('Desc')
            }, {
                Value: 1,
                FontImage: NP.FontImages.arrow_upward,
                Content: NP.RM.getString('Asc')
            }],
            EvItemSelected: () => this._applyFiltersSort()
        });

        this._renderItems([this._root], this._ParentNode || document.documentElement);


        this._sendNotBtn = new Button({
            ParentNode: this._root,
            Class: 'app-button--primary',
            Content: 'Send Notification',
            EvClick: () => this.EvSendNotificationClick.fire(this)
        });

        NP.createNode(this._root, 'app-list-item__meta');

        this._createNotBtn = new Button({
            ParentNode: this._root,
            Class: 'app-button--primary',
            Content: 'Create Schedule',
            EvClick: () => {
                (new EditPushScheduleDlg({
                    Item: {
                        Title: 'New Schedule',
                        Body: 'New Schedule',
                        pushTS: '2024-01-01 00:00:00.0',
                        filter: this.getFilterData()
                    }
                })).show()
            }
        });
    }

    setSortVisible(value: boolean) {
        NP.setIsVisible([this._sortLabel, this._sortDirectionCombo, this._sortFieldCombo], value)
    }


    _applyFiltersSort() {
        this.EvFilterSortChanged.fire(this, this.getFilterData())
    }

    getFilterData(): UserFilter {
        return {
            dateFilter: this._dateFilterCombo.getValue() == 'All' ? null : this._dateFilterCombo.getValue(),
            hasSub: this._hasSubCombo.getValue() == 'All' ? null : this._hasSubCombo.getValue() == 'Yes',
            sortField: this._sortFieldCombo.getValue(),
            sortDirection: this._sortDirectionCombo.getValue(),
            device: this._device.getValue() == 'all' ? null : this._device.getValue(),
        }
    }

    setSortValues(sortField: string, sortDirection: number) {
        this._sortFieldCombo.setValue(sortField, false);
        this._sortDirectionCombo.setValue(sortDirection, false);
    }
}